module.exports = __webpack_public_path__ + "img/erp-logos_0027_dynamicsnav.efa5bbde.jpg";